var app, swapRequiredFields;

app = window.App || (window.App = {});

app.ElementSwapper = (function() {
  function ElementSwapper() {}

  ElementSwapper.prototype.swap = function(event) {
    var selector;
    selector = $(this).data('swap');
    if (!selector) {
      selector = $(this).closest('[data-swap]').data('swap');
    }
    $('.' + selector).slideToggle();
    swapRequiredFields();
    if (event) {
      return event.preventDefault();
    }
  };

  ElementSwapper.prototype.resetRolePersonId = function(event) {
    $('#role_person_id').val(null).change();
    $('#role_person').val(null).change();
    return event.preventDefault();
  };

  return ElementSwapper;

})();

swapRequiredFields = function(rootEl) {
  var required;
  if (rootEl == null) {
    rootEl = document;
  }
  required = rootEl.querySelectorAll('input[required], input[data-required]');
  return required.forEach(function(input) {
    input.required = !input.required;
    return input.dataset.required = !JSON.parse(input.dataset.required || 'false');
  });
};

$(document).on('click', 'a[data-swap], button[data-swap]', new app.ElementSwapper().swap);

$(document).on('click', 'a[data-swap="person-fields"]', new app.ElementSwapper().resetRolePersonId);

$(document).on('turbo:load', function() {
  return document.querySelectorAll('a[data-swap="person-fields"]').forEach(function(link) {
    var hidden, swapClass;
    swapClass = link.dataset.swap;
    hidden = link.closest('.' + swapClass + '[style*="display: none"], .' + swapClass + '[style*="display:none"]');
    if (hidden) {
      return swapRequiredFields(hidden);
    }
  });
});
